import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/pages/MainPage'
import SpotsPage from '@/components/pages/SpotsPage'
import BeginPage from '@/components/pages/BeginPage'
import ContactsPage from '@/components/pages/ContactsPage'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage,
      meta: {
        title: 'Кайтинг в Ульяновске',
        metaTags: [
          {
            name: 'description',
            content: 'Кайтинг в Ульяновске есть и активно развивается. Популярные споты Ульяновска, помощь в обучении кайтингу.'
          },
          {
            property: 'og:description',
            content: 'Кайтинг в Ульяновске есть и активно развивается. Популярные споты Ульяновска, помощь в обучении кайтингу.'
          }
        ]
      }
    },
    {
      path: '/spots/',
      name: 'SpotsPage',
      component: SpotsPage,
      meta: {
        title: 'Популярные споты в Ульяновске',
        metaTags: [
          {
            name: 'description',
            content: 'Самые популярные споты в Ульяновске'
          },
          {
            property: 'og:description',
            content: 'Самые популярные споты в Ульяновске'
          }
        ]
      }
    },
    {
      path: '/begin/',
      name: 'BeginPage',
      component: BeginPage,
      meta: {
        title: 'Советы начинающим кайтерам Ульяновска',
        metaTags: [
          {
            name: 'description',
            content: 'В Ульяновске есть опытные инструкторы по кайтингу, готовые помочь Вам в любом вопросе.'
          },
          {
            property: 'og:description',
            content: 'В Ульяновске есть опытные инструкторы по кайтингу, готовые помочь Вам в любом вопросе'
          }
        ]
      }
    },
    {
      path: '/contacts/',
      name: 'ContactsPage',
      component: ContactsPage,
      meta: {
        title: 'Контактная информация',
        metaTags: [
          {
            name: 'description',
            content: 'Контактная информация. УлКайт - кайтинг в Ульяновске.'
          },
          {
            property: 'og:description',
            content: 'Контактная информация. УлКайт - кайтинг в Ульяновске.'
          }
        ]
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js